import {
  CrossCircleIcon,
  DownArrowIcon,
  TickCircleIcon,
  UpArrowIcon,
} from '@/Components/Common/Icons';
import { InfoCircleOutlined } from '@ant-design/icons';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import './TaskCompliance.less';

const ComplianceStats = ({
  completedTasks,
  missedTasks,
  totalTasks,
  complianceRate,
  periodLabel,
  trend,
}) => {
  const trans = useSelector(translator);

  const hasTasks = totalTasks > 0;
  const rateStr = complianceRate === null ? '-' : Math.abs(complianceRate).toFixed(0);

  return (
    <div className="compliance-summary-card">
      {/* Card header – centered icon + title */}
      <div className="cs-card-header">
        <div className="cs-icon cs-icon--completed black">
          <TickCircleIcon className="cs-tick-icon" />
        </div>
        <span className="cs-header-title">{trans('COMPLIANCE')}</span>
      </div>

      {/* Stat rows */}
      {hasTasks ? (
        <div className="cs-rows">
          {/* Period label with inline rate */}
          <div className="cs-rate-row">
            <span className="cs-period-label">{periodLabel}</span>
            <span className="cs-rate-inline">
              {trend &&
                trend !== 'neutral' &&
                (trend === 'down' ? (
                  <DownArrowIcon className="cs-rate-arrow cs-rate-arrow--down" />
                ) : (
                  <UpArrowIcon className="cs-rate-arrow cs-rate-arrow--up" />
                ))}
              <span
                className={`cs-rate-percent ${
                  trend === 'down' ? 'cs-rate--down' : trend === 'up' ? 'cs-rate--up' : ''
                }`}
              >
                {rateStr}
                {complianceRate !== null && '%'}
              </span>
            </span>
          </div>

          {/* Completed */}
          <div className="cs-row">
            <div className="cs-icon cs-icon--completed">
              <TickCircleIcon className="cs-tick-icon" />
            </div>
            <span className="cs-row-label">
              <span className="cs-count">{completedTasks}</span> {trans('COMPLETED')}
            </span>
          </div>

          {/* Missed */}
          <div className="cs-row">
            <div className="cs-icon cs-icon--missed">
              <CrossCircleIcon className="cs-cross-icon" />
            </div>
            <span className="cs-row-label">
              <span className="cs-count">{missedTasks}</span> {trans('MISSED')}
            </span>
          </div>
        </div>
      ) : (
        <div className="cs-no-tasks">
          <InfoCircleOutlined className="cs-no-tasks-icon" />
          <span className="cs-no-tasks-text">{trans('NO_TASKS_AVAILABLE')}</span>
        </div>
      )}
    </div>
  );
};

ComplianceStats.propTypes = {
  completedTasks: PropTypes.number.isRequired,
  missedTasks: PropTypes.number.isRequired,
  totalTasks: PropTypes.number.isRequired,
  complianceRate: PropTypes.number,
  periodLabel: PropTypes.string.isRequired,
  trend: PropTypes.oneOf(['up', 'down', 'neutral']),
};

export default memo(ComplianceStats);
